"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const FlagBullet_1 = require("@amcharts/amcharts4/.internal/plugins/bullets/FlagBullet");
const PinBullet_1 = require("@amcharts/amcharts4/.internal/plugins/bullets/PinBullet");
const charts_1 = require("@amcharts/amcharts4/charts");
const am4core = require("@amcharts/amcharts4/core");
const core_1 = require("@amcharts/amcharts4/core");
const timeline_1 = require("@amcharts/amcharts4/plugins/timeline");
const animated_1 = require("@amcharts/amcharts4/themes/animated");
const core_2 = require("@angular/core");
const event_bullet_type_1 = require("../../../views/chart/serpentine-timeline/enum/event-bullet-type");
const legend_type_1 = require("../../../views/chart/serpentine-timeline/enum/legend-type");
const chart_base_control_1 = require("../chart-base.control");
const serpentine_chart_control_options_model_1 = require("../shared/serpentine-chart-control-options.model");
let SerpentineTimelineControlComponent = class SerpentineTimelineControlComponent extends chart_base_control_1.ChartBaseControl {
    constructor(ngZone) {
        super();
        this.ngZone = ngZone;
        this.series = new Map();
        this.categories = [];
        this.data = [];
        this.eventData = [];
    }
    ngOnInit() {
        this.ngZone.runOutsideAngular(() => {
            this.initChart();
        });
    }
    ngOnDestroy() {
        this.ngZone.runOutsideAngular(() => {
            this.chart.dispose();
        });
    }
    initChart() {
        am4core.useTheme(animated_1.default);
        this.chart = am4core.create(this.chartContainerElement.nativeElement, timeline_1.SerpentineChart);
        this.setChartDefaults();
        this.setChartOptions();
        this.setScrollbarDefaults();
        (!this.chartOptions || this.chartOptions.legendType !== legend_type_1.LegendType.NONE) && this.setLegendDefaultOptions();
        const dateAxis = this.createDateAxis();
        const categoryAxis = this.createCategoryAxis();
        this.createSeries(dateAxis);
        this.eventData && this.createEventSeries();
        this.setData();
        // init cursor
        let cursor = new timeline_1.CurveCursor();
        this.chart.cursor = cursor;
        cursor.xAxis = dateAxis;
        cursor.yAxis = categoryAxis;
        cursor.lineY.disabled = true;
        cursor.lineX.strokeDasharray = "1,4";
        cursor.lineX.strokeOpacity = 1;
    }
    setData() {
        this.chart.data = this.data;
    }
    createCategoryAxis() {
        let categoryAxis = this.chart.yAxes.push(new charts_1.CategoryAxis());
        categoryAxis.dataFields.category = "category";
        categoryAxis.renderer.grid.template.disabled = true;
        const categoryAxisLabelTemplate = categoryAxis.renderer.labels.template;
        categoryAxisLabelTemplate.paddingRight = 25;
        categoryAxisLabelTemplate.maxWidth = 200;
        categoryAxisLabelTemplate.truncate = true;
        categoryAxisLabelTemplate.tooltipText = '{category}';
        categoryAxis.tooltip.label.maxWidth = 200;
        categoryAxis.tooltip.label.wrap = true;
        categoryAxis.tooltip.getFillFromObject = false;
        categoryAxis.tooltip.background.strokeOpacity = 0.2;
        categoryAxis.tooltip.background.fill = am4core.color("#fff");
        categoryAxis.tooltip.background.cornerRadius = 8;
        categoryAxis.tooltip.label.fill = am4core.color("#000");
        if (this.chartOptions && this.chartOptions.orientation === 'horizontal') {
            categoryAxisLabelTemplate.horizontalCenter = "left";
            categoryAxisLabelTemplate.rotation = 270;
        }
        categoryAxis.renderer.minGridDistance = 10;
        categoryAxis.cursorTooltipEnabled = false;
        return categoryAxis;
    }
    createDateAxis() {
        let dateAxis = this.chart.xAxes.push(new charts_1.DateAxis());
        dateAxis.renderer.tooltipLocation = 0;
        dateAxis.startLocation = -0.5;
        dateAxis.baseInterval = { count: 1, timeUnit: "second" };
        dateAxis.renderer.line.strokeDasharray = "1,4";
        dateAxis.renderer.line.strokeOpacity = 0.6;
        dateAxis.tooltip.background.fillOpacity = 0.2;
        dateAxis.tooltip.background.cornerRadius = 5;
        dateAxis.tooltip.label.fill = new am4core.InterfaceColorSet().getFor("alternativeBackground");
        dateAxis.tooltip.label.paddingTop = 7;
        let labelTemplate = dateAxis.renderer.labels.template;
        labelTemplate.verticalCenter = "middle";
        labelTemplate.fillOpacity = 0.7;
        labelTemplate.background.fill = new am4core.InterfaceColorSet().getFor("background");
        labelTemplate.background.fillOpacity = 1;
        labelTemplate.padding(7, 7, 7, 7);
        return dateAxis;
    }
    createSeries(dateAxis) {
        let series = this.series.values();
        if (this.chartOptions && this.chartOptions.legendType === legend_type_1.LegendType.CATEGORY) {
            series = this.categories;
        }
        for (const seriesItem of series) {
            let series = this.chart.series.push(new timeline_1.CurveColumnSeries());
            series.columns.template.height = am4core.percent(70);
            series.name = seriesItem.name;
            series.dataFields.openDateX = "startDate" + seriesItem.id;
            series.dataFields.dateX = "endDate" + seriesItem.id;
            series.dataFields.categoryY = "category";
            series.columns.template.strokeOpacity = 0;
            series.tooltip.label.interactionsEnabled = true;
            series.tooltip.keepTargetHover = true;
            series.tooltip.getFillFromObject = false;
            series.tooltip.background.fill = am4core.color("#fff");
            series.tooltip.background.width = 320;
            series.columns.template.tooltipText = "{openDateX} - {dateX}";
            series.columns.template.adapter.add('tooltipHTML', this.tooltipAdapter.bind(this));
            // prevent tooltip from closing when hovering out of plot area
            series.tooltip.events.on("shown", () => {
                this.chart.cursor.interactionsEnabled = false;
            });
            series.tooltip.events.on("hidden", () => {
                this.chart.cursor.interactionsEnabled = true;
            });
            let bullet = series.bullets.push(new charts_1.Bullet());
            let rectangle = bullet.createChild(am4core.Rectangle);
            rectangle.width = 11;
            rectangle.height = 1.5;
            rectangle.propertyFields.fill = "color";
            rectangle.propertyFields.stroke = "color";
            rectangle.verticalCenter = "bottom";
            rectangle.horizontalCenter = "middle";
            bullet.locationX = 0;
            bullet.adapter.add("rotation", (value, target) => {
                if (target.dataItem) {
                    let position = dateAxis.dateToPosition(target.dataItem.dateX);
                    return dateAxis.renderer.positionToAngle(position);
                }
                return value;
            });
            let bullet2 = series.bullets.push(new charts_1.Bullet());
            let rectangle2 = bullet2.createChild(am4core.Rectangle);
            rectangle2.width = 11;
            rectangle2.height = 1.5;
            rectangle2.propertyFields.fill = "color";
            rectangle2.propertyFields.stroke = "color";
            rectangle2.verticalCenter = "bottom";
            rectangle2.horizontalCenter = "middle";
            bullet2.locationX = 1;
            bullet2.adapter.add("rotation", (value, target) => {
                if (target.dataItem) {
                    let position = dateAxis.dateToPosition(target.dataItem.openDateX);
                    return dateAxis.renderer.positionToAngle(position);
                }
                return value;
            });
        }
    }
    createEventSeries() {
        let eventSeries = this.chart.series.push(new timeline_1.CurveLineSeries());
        eventSeries.dataFields.dateX = "date";
        eventSeries.dataFields.categoryY = "category";
        eventSeries.hiddenInLegend = true;
        eventSeries.data = this.eventData;
        eventSeries.strokeOpacity = 0;
        let bullet;
        if (this.chartOptions && this.chartOptions.eventBulletType === event_bullet_type_1.EventBulletType.CIRCLE) {
            bullet = eventSeries.bullets.push(new PinBullet_1.PinBullet());
            bullet.disabled = false;
            bullet.locationX = 0;
            bullet.background.radius = 20;
            if (this.chartOptions.hasEventIcon) {
                bullet.image = new am4core.Image();
                bullet.image.scale = 0.5;
                bullet.image.propertyFields.href = "imageURL";
            }
            else {
                bullet.label = new core_1.Label();
                bullet.label.propertyFields.text = "name";
                bullet.label.truncate = true;
                bullet.label.maxWidth = 40;
                bullet.label.stroke = am4core.color("#111");
            }
            bullet.background.fill = am4core.color("#a3a3a3");
            bullet.background.fillOpacity = 0.6;
            bullet.background.strokeOpacity = 0;
            bullet.background.pointerBaseWidth = 8;
            bullet.background.pointerLength = 8;
        }
        else {
            bullet = eventSeries.bullets.push(new FlagBullet_1.FlagBullet());
            bullet.label.propertyFields.text = "name";
            bullet.label.truncate = true;
            bullet.label.maxWidth = 50;
            bullet.locationX = 0;
            bullet.tooltipText = "{name}";
        }
        eventSeries.tooltip.label.interactionsEnabled = true;
        eventSeries.tooltip.keepTargetHover = true;
        eventSeries.tooltip.getFillFromObject = false;
        eventSeries.tooltip.background.fill = am4core.color("#fff");
        // prevent tooltip from closing when hovering out of plot area
        eventSeries.tooltip.events.on("shown", () => {
            this.chart.cursor.interactionsEnabled = false;
        });
        eventSeries.tooltip.events.on("hidden", () => {
            this.chart.cursor.interactionsEnabled = true;
        });
        bullet.adapter.add('tooltipHTML', (value, target) => {
            const dataItem = target.dataItem;
            if (dataItem) {
                const dataContext = dataItem.dataContext;
                let tooltipTemplate = '<div class="rc-serp-tooltip">';
                if (dataContext.roadUrl) {
                    tooltipTemplate +=
                        `<div>
                            <a href="${dataContext.roadUrl}">
                            ${dataItem.categoryY}
                            </a>
                        </div>`;
                }
                else {
                    tooltipTemplate +=
                        `<div class="rc-serp-tooltip__title">
                             ${dataItem.categoryY}
                         </div>`;
                }
                if (dataContext.url) {
                    tooltipTemplate +=
                        `<div>
                            <a href="${dataContext.url}">
                            ${dataContext.name}
                           </a>
                        </div>`;
                }
                else {
                    tooltipTemplate +=
                        `<div class="rc-serp-tooltip__title">
                             ${dataContext.name}
                        </div>`;
                }
                const measures = target.dataItem.dataContext[`measures`];
                measures && measures.forEach((measure) => {
                    tooltipTemplate +=
                        ` <div class="rc-serp-tooltip__property">
                             <div class="rc-serp-tooltip__text">${measure.name}</div>
                             <div class="rc-serp-tooltip__value">${measure.value}</div>
                        </div>`;
                });
                tooltipTemplate += '</div>';
                return tooltipTemplate;
            }
            return '';
        });
    }
    setChartDefaults() {
        this.chart.curveContainer.padding(50, 40, 50, 40);
        this.chart.dateFormatter.dateFormat = "yyyy-MM-dd HH:mm:ss";
        this.chart.fontSize = 11;
        // for flag visibility
        this.chart.maskBullets = false;
        this.chart.responsive.enabled = true;
    }
    setChartOptions() {
        if (this.chartOptions) {
            this.chart.orientation = this.chartOptions.orientation;
            this.chart.levelCount = this.chartOptions.levelCount;
            this.chart.colors.list = this.chartOptions.chartPalette.map(color => am4core.color(color));
            this.setRTLDefaultOptions();
        }
    }
    setLegendDefaultOptions() {
        // Legend Options
        this.chart.legend = new charts_1.Legend();
        const legend = this.chart.legend;
        legend.maxHeight = 150;
        legend.scrollable = true;
        legend.labels.template.paddingTop = 2;
        legend.labels.template.contentHeight = 10;
        legend.labels.template.fontSize = 12;
        legend.markers.template.width = 14;
        legend.markers.template.height = 14;
        legend.marginTop = 24;
    }
    setRTLDefaultOptions() {
        if (this.chartOptions.isRTL) {
            // Set RTL for labels
            this.chart.rtl = true;
            // Change the order of the items in legend, so that first item starts on the right
            this.chart.legend.reverseOrder = true;
            // Flip legend
            this.chart.legend.itemContainers.template.reverseOrder = true;
        }
    }
    setScrollbarDefaults() {
        this.chart.scrollbarX = new am4core.Scrollbar();
        this.chart.scrollbarX.align = "center";
        this.chart.scrollbarX.width = am4core.percent(85);
        this.chart.scrollbarX.thumb.minWidth = 50;
        this.chart.scrollbarX.minHeight = 4;
        this.chart.scrollbarX.startGrip.icon.disabled = true;
        this.chart.scrollbarX.endGrip.icon.disabled = true;
    }
    tooltipAdapter(value, target) {
        const dataItem = target.dataItem;
        if (dataItem) {
            const dataContext = dataItem.dataContext;
            let tooltipTemplate = '<div class="rc-serp-tooltip">';
            if (dataContext.url) {
                tooltipTemplate +=
                    `<div>
                        <a href="${dataContext.url}">
                         ${dataItem.categoryY}
                        </a>
                     </div>`;
            }
            else {
                tooltipTemplate +=
                    `<div class="rc-serp-tooltip__title">
                        ${dataItem.categoryY}
                    </div>`;
            }
            let seriesItem = this.series.get(dataContext.seriesId);
            if (seriesItem.url) {
                tooltipTemplate +=
                    `<div>
                        <a href="${seriesItem.url}">
                        ${seriesItem.name}
                        </a>
                     </div>`;
            }
            else {
                tooltipTemplate +=
                    `<div class="rc-serp-tooltip__title">
                        ${seriesItem.name}
                    </div>`;
            }
            const measures = dataContext[`measures${seriesItem.id}`];
            measures && measures.forEach((measure) => {
                tooltipTemplate +=
                    ` <div class="rc-serp-tooltip__property">
                        <div class="rc-serp-tooltip__text">${measure.name}</div>
                        <div class="rc-serp-tooltip__value">${measure.value}</div>
                    </div>`;
            });
            tooltipTemplate += '</div>';
            return tooltipTemplate;
        }
        return '';
    }
};
__decorate([
    core_2.Input(),
    __metadata("design:type", String)
], SerpentineTimelineControlComponent.prototype, "id", void 0);
__decorate([
    core_2.Input(),
    __metadata("design:type", Map)
], SerpentineTimelineControlComponent.prototype, "series", void 0);
__decorate([
    core_2.Input(),
    __metadata("design:type", Array)
], SerpentineTimelineControlComponent.prototype, "categories", void 0);
__decorate([
    core_2.Input(),
    __metadata("design:type", Array)
], SerpentineTimelineControlComponent.prototype, "data", void 0);
__decorate([
    core_2.Input(),
    __metadata("design:type", Array)
], SerpentineTimelineControlComponent.prototype, "eventData", void 0);
__decorate([
    core_2.Input(),
    __metadata("design:type", serpentine_chart_control_options_model_1.SerpentineChartControlOptionsModel)
], SerpentineTimelineControlComponent.prototype, "chartOptions", void 0);
__decorate([
    core_2.ViewChild('chartContainer'),
    __metadata("design:type", core_2.ElementRef)
], SerpentineTimelineControlComponent.prototype, "chartContainerElement", void 0);
SerpentineTimelineControlComponent = __decorate([
    core_2.Component({
        
        selector: 'sis-serpentine-timeline-control',
        styles: [require('./serpentine-timeline-control.component.css')],
        template: require('./serpentine-timeline-control.component.html')
    }),
    __metadata("design:paramtypes", [core_2.NgZone])
], SerpentineTimelineControlComponent);
exports.SerpentineTimelineControlComponent = SerpentineTimelineControlComponent;
//# sourceMappingURL=serpentine-timeline-control.component.js.map